import { render, staticRenderFns } from "./empty-page.vue?vue&type=template&id=7c919da2&scoped=true&"
import script from "./empty-page.vue?vue&type=script&lang=js&"
export * from "./empty-page.vue?vue&type=script&lang=js&"
import style0 from "./empty-page.vue?vue&type=style&index=0&id=7c919da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c919da2",
  null
  
)

export default component.exports